module.exports = __webpack_public_path__ + "img/sheet-guide.28d00af0.png";